export default {
  invalid_request: "The request is invalid. Check your input.",
  invalid_key: "The device key is invalid or has expired.",
  not_authenticated: "Sign in to continue.",
  not_authorized: "You do not have permission to perform this action.",
  device_disabled: "This device is disabled.",
  device_mismatch: "The device ID does not match the device key.",
  virtual_device_immutable: "The server device cannot be changed or deleted.",
  virtual_device_membership_immutable: "The server device is a permanent Channel member.",
  virtual_device_receive_forbidden: "The server device cannot receive clipboard items from other devices.",
  channel_forbidden: "The device is not a member of this Channel.",
  not_found: "The requested resource no longer exists.",
  item_conflict: "This item ID is already in use. Publish a new item.",
  configuration_conflict: "Cleanup settings are overridden by environment variables or an imported configuration. Update that source before saving.",
  content_not_ready: "The full content is not ready yet.",
  source_content_missing: "The source device no longer has this content.",
  too_large: "The content exceeds the server's size limit.",
  hash_mismatch: "Content verification failed. Try uploading again.",
  transfer_expired: "This transfer has expired. Start a new transfer.",
  rate_limited: "Too many requests. Try again later.",
  internal_error: "The server could not complete the request.",
  cancelled: "The transfer was cancelled.",
  upload_failed: "The upload failed.",
  item_removed: "The clipboard item was removed.",
} as const
